'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = withStyles;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function withStyles(obj) {
  return function (Target) {
    (0, _validators.validateClass)(Target, 'pureComponent');

    return function (props) {
      return _react2['default'].createElement(Target, _extends({ styles: obj }, props));
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/withStyles.js
// module id = 560
// module chunks = 1